<div class="modal-container">
  <div class="header-container">{{ configs[currentMode].title }}</div>
  <div class="form-container">
    <div class="account-container">
      <div class="account-name-container">
        <app-titled-input [control]="name" [title]="'Account name'">
          <ng-content>
            <input type="text" [formControl]="name">
          </ng-content>
        </app-titled-input>
      </div>
      <div class="account-key-container">
        <app-titled-input [control]="key" [title]="'Account key'">
          <ng-content>
            <input type="text" [formControl]="key">
          </ng-content>
        </app-titled-input>
      </div>
    </div>
    <div class="select-menu-input-wrapper">
      <app-titled-input [control]="brands" [title]="'Brands'">
      </app-titled-input>
      <app-select-menu [items]="brandOptions" [placeholder]="'Select brand'" [searchable]="true" [control]="brands"
        [selectMode]="SelectMode.MULTI" [selectAllAndClearOptions]="true" [groupBySelected]="true" [virtualScroll]="true"></app-select-menu>
    </div>
    <div class="account-users-container" *ngIf="FormMode.EDIT === currentMode">
      <label>Users</label>
      <br>
      <div class="users-list-container">
        {{accountUsers?.join(', ')}}
      </div>
    </div>
  </div>
  <div class="buttons-container">
    <app-button (clicked)="cancel()" class="cancel" text="cancel"></app-button>
    <app-button (clicked)="submit()" [class]="form.invalid? 'primary disabled' : 'primary'"
      [text]="configs[currentMode].submitText"></app-button>
  </div>
</div>
